module.exports = {
  bugsnagApiKey: '03942f6e9d3bc7c201779f256eb6a607',
  appVersion: '1.5.1',
  buildNumber: 9,
  internalBuildNumber: 51,
};
